<script>
import { Line } from 'vue-chartjs'
import Chart from 'chart.js'
import annotation from 'chartjs-plugin-annotation'

// register the annotation plugin once
Chart.plugins.register(annotation)

export default {
  name: 'AveragePricesChart',
  extends: Line,

  props: {
    prices: {  type: Array,  required: true },  // [{ id, price }]
    min:    {  type: Number, required: true },
    median: {  type: Number, required: true },
    max:    {  type: Number, required: true },
    width:  {  type: Number, default: 400 },
    height: {  type: Number, default: 200 }
  },

  computed: {
    _values() {
      return this.prices.map(p => p.price)
    },

    chartData() {
      return {
        labels: this._values.map((_,i) => i),
        datasets: [{
          label:          'Price (€)',
          data:           this._values,
          fill:           false,
          borderColor:    'lightgray',
          borderWidth:    2,
          pointRadius:    4,
          pointHoverRadius: 6
        }]
      }
    },

    chartOptions() {
      const vals      = this._values
      const count     = vals.length
      const maxLabels = 10
      const minVal    = this.min
      const medVal    = this.median
      const maxVal    = this.max

      return {
        annotation: {
          annotations: [
            {
              type: 'line', mode: 'horizontal', scaleID: 'y-axis-0',
              value: minVal, borderColor: '#0e9f6e', borderDash: [5,5]
            },
            {
              type: 'line', mode: 'horizontal', scaleID: 'y-axis-0',
              value: medVal, borderColor: '#e3a008', borderDash: [5,5]
            },
            {
              type: 'line', mode: 'horizontal', scaleID: 'y-axis-0',
              value: maxVal, borderColor: '#c81e1e', borderDash: [5,5]
            }
          ]
        },

        scales: {
          xAxes: [{
            scaleLabel:    { display: true, labelString: 'Item Index' },
            ticks:         { autoSkip: true, maxTicksLimit: Math.min(count, maxLabels) }
          }],

          yAxes: [
            // ───── Primary left axis ─────
            {
              id:       'y-axis-0',
              type:     'logarithmic',
              position: 'left',
              scaleLabel: {
                display:     true,
                labelString: 'Price (€)'
              },
              ticks: {
                min:  Math.max(minVal, 0.1),
                max:  maxVal,
                callback: v =>
                    v === medVal
                        ? ''
                        : Number(v.toPrecision(3))
              },
              afterBuildTicks(axis) {
                const t = []
                let v = Math.pow(10, Math.floor(Math.log10(minVal||1)))
                while (v <= maxVal) { t.push(v); v *= 10 }
                t.push(medVal)
                axis.ticks = t.sort((a,b) => a - b)
              }
            },

            // ───── Secondary right axis ─────
            {
              id:       'y-axis-1',
              type:     'logarithmic',
              position: 'right',
              offset:   true,
              gridLines: {
                drawOnChartArea: false,
                drawBorder:      false
              },
              scaleLabel: {
                display: false
              },
              ticks: {
                min:  Math.max(minVal, 0.1),
                max:  maxVal,
                callback: v =>
                    v === medVal
                        ? `€${v.toLocaleString()}`
                        : '',
                fontColor: '#e3a008',
                padding:   0
              },
              afterBuildTicks(axis) {
                axis.ticks = [ medVal ]
              }
            }
          ]
        },

        legend: { display: false },
        onClick: (evt, active) => {
          if (!active.length) return
          const idx = active[0]._index
          window.open(`/broadcasts/${this.prices[idx].id}`, '_blank')
        }
      }
    }
  },

  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
</script>
